import { render, staticRenderFns } from "./customer_note.vue?vue&type=template&id=2ddb2996&scoped=true"
import script from "./customer_note.vue?vue&type=script&lang=js"
export * from "./customer_note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddb2996",
  null
  
)

export default component.exports